import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { learnSlugRedirects } from '../content/faqContent';

function LearnRedirect() {
  const { slug } = useParams();

  if (slug) {
    const target = learnSlugRedirects[slug] || slug;
    return <Navigate to={`/faq/${target}`} replace />;
  }

  return <Navigate to="/faq" replace />;
}

export default LearnRedirect;
